import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

// Context yaratmaq
export const ApiLinkContext = createContext();

const ApiLinkProvider = ({ children }) => {
  const [coaching, setCoaching] = useState([]);
  const [blogCat, setBlogCat] = useState([]);
  const [blog, setBlog] = useState([]);
  const [projects, setProjects] = useState([]);
  const [bio, setBio] = useState([]);
  const [main, setMain] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [cvCategory,setCvCategory] = useState([])
  const [cv,setCv] = useState([])
  const [companyList,setCompanyList] = useState([])




  // ABUNELIK
  const [subsCoach,setSubsCoach] = useState([])
  const [subsJob,setSubsJob] = useState([])
  const [subsEmp,setSubsEmp] = useState([]) 



  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiName = [
    "sessiyalar",
    "cat",
    "blog",
    "lahiye",
    "bio",
    "main",
    "testi",
    // Start Abunelik
    "subsone",
    "substwo",
    "substhr",
    "jCat",
    "list-cv",
    "list-is"

    // End Abunelik
  ];

  useEffect(() => {
    const apiCalls = apiName.map((item) => {
      return axios.get(`https://www.turanozbahceci.com/api/${item}.php`);
    });
    Promise.all(apiCalls)
      .then(
        ([
          coachingRes,
          blogCatRes,
          blogRes,
          lahiyeRes,
          bioRes,
          mainRes,
          testimonialsRes,
          subsOneRes,
          subsTwoRes,
          subsThrRes,
          jCatRes,
          listCv,
          listRes
        ]) => {
          setCoaching(coachingRes.data);
          setBlogCat(blogCatRes.data);
          setBlog(blogRes.data);
          setProjects(lahiyeRes.data);
          setBio(bioRes.data);
          setMain(mainRes.data);
          setTestimonials(testimonialsRes.data);
          setSubsCoach(subsOneRes.data.subscriptions) ;
          setSubsJob(subsTwoRes.data.subscriptions);
          setSubsEmp(subsThrRes.data.subscriptions);
          setCvCategory(jCatRes.data.categories);
          setCv(listCv.data.cvList)
          
          setCompanyList(listRes.data.isElanlariList);
          
          setLoading(false);
        }
      )
      .catch((err) => {
        setLoading(false);
        setError(err);
      });
  }, []);

  return (
    <ApiLinkContext.Provider
      value={{
        coaching,
        blogCat,
        blog,
        projects,
        bio,
        main,
        testimonials,
        cvCategory,
        cv,
        subsCoach,
        subsJob,
        subsEmp,
        companyList,
        loading,
        error,
      }}
    >
      {children}
    </ApiLinkContext.Provider>
  );
};

export default ApiLinkProvider;
